(function () {
  var popup = document.querySelector('[data-rozino-discount-popup]');

  if (!popup || window.Shopify && window.Shopify.designMode) {
    return;
  }

  var storageKey = 'rozinoDiscountPopupDismissed';
  var closeButtons = popup.querySelectorAll('[data-rozino-discount-close]');
  var copyButton = popup.querySelector('[data-rozino-discount-copy]');
  var firstFocusable = popup.querySelector('button');

  function wasDismissed() {
    try {
      if (window.localStorage.getItem(storageKey) === 'true') {
        return true;
      }
    } catch (error) {
      return document.cookie.indexOf(storageKey + '=true') !== -1;
    }

    return document.cookie.indexOf(storageKey + '=true') !== -1;
  }

  function markDismissed() {
    try {
      window.localStorage.setItem(storageKey, 'true');
    } catch (error) {
      document.cookie = storageKey + '=true; max-age=2592000; path=/; SameSite=Lax';
    }

    document.cookie = storageKey + '=true; max-age=2592000; path=/; SameSite=Lax';
  }

  function openPopup() {
    popup.hidden = false;
    document.documentElement.classList.add('overflow-hidden');

    if (firstFocusable) {
      firstFocusable.focus();
    }
  }

  function closePopup() {
    popup.hidden = true;
    document.documentElement.classList.remove('overflow-hidden');
    markDismissed();
  }

  if (!wasDismissed()) {
    window.setTimeout(openPopup, 1600);
  }

  closeButtons.forEach(function (button) {
    button.addEventListener('click', closePopup);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && !popup.hidden) {
      closePopup();
    }
  });

  if (copyButton) {
    copyButton.addEventListener('click', function () {
      var code = copyButton.getAttribute('data-code') || 'NEW';

      function setCopiedLabel() {
        copyButton.textContent = 'Code copied';
        window.setTimeout(function () {
          copyButton.textContent = 'Copy code';
        }, 2400);
      }

      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(code).then(setCopiedLabel).catch(setCopiedLabel);
        return;
      }

      setCopiedLabel();
    });
  }
})();
